import Price from '../../components/lakeview/Price';

const columns = [
  {
    field: 'tmpId',
    type: 'tmpId',
    sort: 'asc',
    width: 150,
  },
  {
    field: 'paymentDate',
    label: 'Data tranzakcji',
    sort: 'asc',
    width: 180,
  },
  {
    field: 'transactionType',
    label: 'Rodzaj tranzakcji',
    type: 'enum',
    enumType: "enums/transactionType",
    width: 200,
  },
  {
    field: 'paymentType',
    label: 'Typ płatności',
    type: 'custom',
    custom: function (column, row) {
      return row.paymentType?.name || '-';
    },
    width: 200,
  },
  {
    field: 'amount',
    label: 'Kwota',
    type: 'custom',
    exportValue: (row) => row.amount,
    custom: function (column, row) {
      return <Price value={row.amount} />;
    },
    width: 120,
  },
  {
    field: 'paymentComment',
    label: 'Komentarz',
    type: 'text',
    width: 300,
  },
  {
    field: 'confirmed',
    label: 'Potwierdzone',
    type: 'boolean',
    defaultValue: 'true',
    width: 130,
  }
];

export default columns;
